import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { getFormValues } from 'redux-form';
import Pusher from 'pusher-js';

import * as actConfirmAction from 'actions/ingredients/recipes';
import * as clevertapIngredientRecipes from 'clevertap/ingredient/recipes';

import { PUSHER_APP_KEY, INVENTORY_PUSHER_CHANNEL } from 'api/constants';
import { checkerPusherUpdate } from 'utils/pusherChecker';
import FormStep from '../FormStep';
import ContainStep from './ContainStep';
import styles from './CreateRecipesModal.css';
import LoadingSpinner from './LoadingSpinner';

const cx = classNames.bind(styles);

class CreateRecipesModal extends React.Component {
  componentDidMount() {
    const { businessId, outletId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(
      INVENTORY_PUSHER_CHANNEL(businessId, outletId)
    );
  }

  componentDidUpdate() {
    const { idAsyncJob, dispatch, search } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    this.channel.bind('library/recipe/import', data => {
      if (checkerPusherUpdate(idAsyncJob, data, 'import-done')) {
        dispatch(actConfirmAction.successUpload());
        dispatch(actConfirmAction.recipesRequest({ page: 1 }, []));
        clevertapIngredientRecipes.importRecipeSuccess(search.outletIds[0]);
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        data.type === 'import-done' &&
        !data.success
      ) {
        dispatch(
          actConfirmAction.responseUploadFailed(data.error, search.outletIds)
        );
        dispatch(actConfirmAction.nextStepCreateRecipes());
      }
    });
  }

  render() {
    const { showCreateRecipesModal, createRecipesForm } = this.props;
    const isEnable =
      (createRecipesForm.step === 2 && createRecipesForm.importType) ||
      (createRecipesForm.step === 3 && createRecipesForm.isUploadImage);
    const titleImportButton = [2, 3];
    const modalBodyClassNames = this._getModalBodyClassNames(createRecipesForm);
    const modalFooterClassNames = this._getModalFooterClassNames(
      createRecipesForm
    );
    const modalButtonImportClassNames = this._getModalButtonImportClassNames(
      isEnable
    );
    return (
      <Modal show={showCreateRecipesModal} dialogClassName={`${styles.dialog}`}>
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
            {' '}
            Import Recipes{' '}
          </Modal.Title>
          {!createRecipesForm.isLoading ? (
            <span
              onClick={this._handleCloseButton}
              className={styles['button-close']}
            >
              {' '}
              &times;{' '}
            </span>
          ) : null}
        </Modal.Header>
        <LoadingSpinner showLoadingSpinner={createRecipesForm.isLoading} />
        <Modal.Body className={modalBodyClassNames}>
          <FormStep />
          <ContainStep />
        </Modal.Body>
        <Modal.Footer className={modalFooterClassNames}>
          {createRecipesForm.step === 4 ? null : (
            <button
              className={`${styles['cancel-button']} btn btn-default`}
              onClick={this._handleClose}
            >
              {' '}
              {this._getButtonTitleFooter()}{' '}
            </button>
          )}
          {titleImportButton.includes(createRecipesForm.step) ? (
            <button
              className={modalButtonImportClassNames}
              onClick={this._handleNext}
              disabled={!isEnable}
            >
              Import
            </button>
          ) : (
            <button
              className="btn btn-primary ml-10px"
              onClick={this._handleNext}
            >
              {' '}
              {createRecipesForm.step === 4 ? (
                <div>
                  {createRecipesForm.isError
                    ? this._getButtonErrorText()
                    : 'Done'}
                </div>
              ) : (
                'Next'
              )}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  _getButtonErrorText = () => {
    const {
      createRecipesForm: { messages },
    } = this.props;
    if (Array.isArray(messages)) {
      return 'Download Error List and Exit';
    }
    return 'Update Import Recipe';
  };

  _getButtonTitleFooter = () => {
    const {
      createRecipesForm: { step },
    } = this.props;
    const titleImportButton = [2, 3];
    if (titleImportButton.includes(step)) {
      return 'Back';
    }
    return 'Cancel';
  };

  _handleCloseButton = () => {
    this.props.dispatch(actConfirmAction.closeCreateRecipesModal());
    this.props.dispatch(actConfirmAction.resetModalImportRecipe());
  };

  _handleClose = () => {
    const {
      createRecipesForm: { isError, step },
      dispatch,
    } = this.props;
    const titleImportButton = [2, 3];
    if (titleImportButton.includes(step)) {
      dispatch(actConfirmAction.backStepCreateRecipes());
      return;
    }
    if (isError) {
      this._handleDownloadErrorList();
    } else {
      this.props.dispatch(actConfirmAction.closeCreateRecipesModal());
      this.props.dispatch(actConfirmAction.resetModalImportRecipe());
    }
  };

  _handleHideModal = () => {
    this.props.dispatch(actConfirmAction.closeCreateRecipesModal());
  };

  _handleUpdateIncorrectData = () => {
    this.props.dispatch(actConfirmAction.updateIncorrect());
  };

  _handleNext = async () => {
    const {
      createRecipesForm: { step, fileFormData },
      dispatch,
      search,
      businessId,
    } = this.props;
    if (step === 3) {
      dispatch(
        actConfirmAction.importRecipe(
          {
            outletId: search.outletIds[0],
            businessId,
          },
          fileFormData,
          search.outletIds[0]
        )
      );
    } else if (step === 4) {
      this._handleClose();
    } else {
      dispatch(actConfirmAction.nextStepCreateRecipes());
    }
  };

  _handleDownloadErrorList = () => {
    const {
      idAsyncJob,
      dispatch,
      search,
      createRecipesForm: { messages },
    } = this.props;
    if (Array.isArray(messages)) {
      const prefix = 'Recipes - ';
      dispatch(
        actConfirmAction.startDownloadErrorListImportRecipe(
          {
            keyword: '',
            outletName: search.outletName,
            email: search.email,
            is_export_template: true,
            export_task: 'error_list',
            async_job_id: idAsyncJob,
          },
          prefix,
          search.outletIds[0]
        )
      );
    } else {
      dispatch(actConfirmAction.updateIncorrect());
    }
  };

  _getModalBodyClassNames = props => {
    const { isLoading } = props;
    return cx({ 'modal-loading': isLoading });
  };

  _getModalFooterClassNames = props => {
    const { isLoading } = props;
    return cx({ 'modal-footer': true, 'modal-loading': isLoading });
  };

  _getModalButtonImportClassNames = isEnable => {
    return cx({
      btn: true,
      'btn-primary': isEnable,
      'btn-default': !isEnable,
      'disable-button': !isEnable,
    });
  };
}

function mapStateToProps(state) {
  const currentOutletId = state.moka.user.outlet_id[0];
  return {
    ...state.ingredients.recipes,
    businessId: state.moka.user.business.id,
    outletId: currentOutletId,
    search: getFormValues('search')(state),
  };
}

export default connect(mapStateToProps)(CreateRecipesModal);
